import { Duration, Fields } from './styles'

Duration.Fields = Fields

export default Duration
